module.exports = __webpack_public_path__ + "static/media/refund.38d44719.svg";